<template>
  <div class="collateral-property-list">
    <h3 class="collateral-property-list__title">Типовые формы договора купли-продажи недвижимости</h3>
    <div class="collateral-property-list__container">
      <p class="collateral-property-list__type">Документы</p>
      <div class="collateral-property-list__line"></div>
      <template v-if="list">
        <a class="collateral-property-list__link" v-for="(item, index) in list" :key="index" target="_blank" :title="item.title" :href="item.file.src" v-show="count > index">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3 15.0033C3.55228 15.0033 4 15.451 4 16.0033V21.0033H20V16.0033C20 15.451 20.4477 15.0033 21 15.0033C21.5523 15.0033 22 15.451 22 16.0033V21.2533C22 21.7824 21.7464 22.2437 21.3766 22.5518C21.0121 22.8556 20.5509 23.0033 20.1 23.0033H3.9C3.44908 23.0033 2.98792 22.8556 2.62342 22.5518C2.2536 22.2437 2 21.7824 2 21.2533V16.0033C2 15.451 2.44772 15.0033 3 15.0033Z" fill="#82BF00"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0114 16.4033C11.4591 16.4033 11.0114 15.9556 11.0114 15.4033V3.40332C11.0114 2.85104 11.4591 2.40332 12.0114 2.40332C12.5637 2.40332 13.0114 2.85104 13.0114 3.40332V15.4033C13.0114 15.9556 12.5637 16.4033 12.0114 16.4033Z" fill="#82BF00"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7124 16.2108C12.322 16.6008 11.6894 16.6008 11.299 16.2108L6.76399 11.6808C6.37325 11.2905 6.3729 10.6573 6.76321 10.2666C7.15352 9.87584 7.78668 9.87549 8.17742 10.2658L12.0057 14.0899L15.834 10.2658C16.2247 9.87549 16.8579 9.87584 17.2482 10.2666C17.6385 10.6573 17.6382 11.2905 17.2474 11.6808L12.7124 16.2108Z" fill="#82BF00"/>
          </svg>
          <span>{{ item.title }} {{item.file.extension}}, {{item.file.size_short}}</span>
        </a>

      </template>
        <div class="collateral-property-list__button-container" v-if="active">
          <button class="collateral-property-list__button" @click="updateList">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M4.99996 2.00293C4.44767 2.00293 3.99996 2.45065 3.99996 3.00294L3.99999 6.38741C3.99999 6.93969 4.4477 7.3874 4.99999 7.3874H8.5C9.05229 7.3874 9.5 6.93969 9.5 6.3874C9.5 5.83512 9.05229 5.3874 8.5 5.3874H7.50051C8.78277 4.51343 10.3315 4.00326 12 4.00326C16.4183 4.00326 20 7.58498 20 12.0033C20 12.5555 20.4477 13.0033 21 13.0033C21.5523 13.0033 22 12.5555 22 12.0033C22 6.48041 17.5228 2.00326 12 2.00326C9.74889 2.00326 7.67091 2.74782 5.99997 4.0027L5.99996 3.00292C5.99996 2.45064 5.55224 2.00293 4.99996 2.00293ZM3 11.0033C2.44772 11.0033 2 11.451 2 12.0033C2 17.5261 6.47715 22.0033 12 22.0033C14.226 22.0033 16.2829 21.2752 17.9443 20.0454L17.9443 21.0033C17.9443 21.5556 18.392 22.0033 18.9443 22.0033C19.4966 22.0033 19.9443 21.5555 19.9443 21.0032L19.9442 17.7717C19.9442 17.5064 19.8388 17.2521 19.6513 17.0645C19.4637 16.877 19.2093 16.7717 18.9441 16.7717L15.6966 16.7721C15.1443 16.7722 14.6967 17.2199 14.6967 17.7722C14.6968 18.3245 15.1446 18.7722 15.6969 18.7721L16.2665 18.772C15.0316 19.5523 13.5688 20.0033 12 20.0033C7.58172 20.0033 4 16.4215 4 12.0033C4 11.451 3.55228 11.0033 3 11.0033Z" fill="#252628"/>
            </svg>
            <span>Показать еще</span>
          </button>
        </div>
    </div>
  </div>

</template>
<script>
import axios from 'axios'
export default {
  name:"CollateralPropertyList",
  //props: ['list'],
  data(){
    return {
      apiUrl: '/api/v2/land/property/standardforms/',
      count: 5,
      active: true,
      list: []
    }
  },
  mounted(){
    this.getData()
  },
  methods:{
    updateList(){
      if(this.list.length <= (this.count + 5)){
        this.count = this.list.length
        this.active = false
      } else {
        this.count += 5
      }
    },
    getData(){
      new Promise((resolve) => {
        axios.get(this.apiUrl)
            .then((response) => {
              this.list = response.data.data
            })
            .catch(() => {});
      });
    }
  }
}
</script>